"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import React from "react";
const ProjectBrowser = dynamic(() => import("#/features/project/ui/ProjectBrowser/ProjectBrowser").then(module => ({
  default: module.ProjectBrowser
})), {
  ssr: false
});

/** Global project browser modal — loaded client-only so the page shell stays a Server Component. */
export const ProjectBrowserOverlay: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProjectBrowser />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};